
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const DutyPeriodType = {
  SevenDaysOffPerMonth: 'SevenDaysOffPerMonth',
  TwoWeeksOnOff: 'TwoWeeksOnOff',
  ThreeWeeksOnOff: 'ThreeWeeksOnOff',
  OneMonthOnOff: 'OneMonthOnOff',
  TwoMonthsOnOff: 'TwoMonthsOnOff',
  Custom: 'Custom'
} as const

export type DutyPeriodType = (typeof DutyPeriodType)[keyof typeof DutyPeriodType]


export const CrewRole = {
  FlightAttendant: 'FlightAttendant',
  JuniorFlightAttendant: 'JuniorFlightAttendant',
  SeniorFlightAttendant: 'SeniorFlightAttendant',
  LeadFlightAttendant: 'LeadFlightAttendant',
  JuniorPilot: 'JuniorPilot',
  SeniorPilot: 'SeniorPilot',
  LeadPilot: 'LeadPilot',
  Engineer: 'Engineer',
  GeneralManager: 'GeneralManager'
} as const

export type CrewRole = (typeof CrewRole)[keyof typeof CrewRole]


export const RosterHistoryOperation = {
  Assign: 'Assign',
  Clear: 'Clear'
} as const

export type RosterHistoryOperation = (typeof RosterHistoryOperation)[keyof typeof RosterHistoryOperation]


export const TemperatureUnit = {
  Fahrenheit: 'Fahrenheit',
  Celsius: 'Celsius'
} as const

export type TemperatureUnit = (typeof TemperatureUnit)[keyof typeof TemperatureUnit]


export const TimezoneDisplay = {
  UTC: 'UTC',
  Local: 'Local',
  Zulu: 'Zulu'
} as const

export type TimezoneDisplay = (typeof TimezoneDisplay)[keyof typeof TimezoneDisplay]


export const DutyStatus = {
  OffDuty: 'OffDuty',
  OnDuty: 'OnDuty',
  Standby: 'Standby',
  Training: 'Training',
  Leave: 'Leave',
  Sick: 'Sick',
  Positioning: 'Positioning'
} as const

export type DutyStatus = (typeof DutyStatus)[keyof typeof DutyStatus]


export const DocumentCategory = {
  Crew: 'Crew',
  Passenger: 'Passenger',
  Compliance: 'Compliance',
  Aircraft: 'Aircraft'
} as const

export type DocumentCategory = (typeof DocumentCategory)[keyof typeof DocumentCategory]


export const DocumentSubType = {
  Passport: 'Passport',
  Visa: 'Visa',
  TrainingDocument: 'TrainingDocument',
  CrewID: 'CrewID',
  MedicalCertificate: 'MedicalCertificate',
  License: 'License',
  TravelID: 'TravelID',
  Manual: 'Manual',
  SOP: 'SOP',
  Checklist: 'Checklist',
  Policy: 'Policy',
  Other: 'Other'
} as const

export type DocumentSubType = (typeof DocumentSubType)[keyof typeof DocumentSubType]


export const TripState = {
  Draft: 'Draft',
  Scheduled: 'Scheduled',
  Complete: 'Complete'
} as const

export type TripState = (typeof TripState)[keyof typeof TripState]


export const PassengerTier = {
  Platinum: 'Platinum',
  Gold: 'Gold',
  Silver: 'Silver',
  Standard: 'Standard'
} as const

export type PassengerTier = (typeof PassengerTier)[keyof typeof PassengerTier]


export const PassengerRole = {
  Primary: 'Primary',
  Guest: 'Guest'
} as const

export type PassengerRole = (typeof PassengerRole)[keyof typeof PassengerRole]


export const TaskStatus = {
  Draft: 'Draft',
  Submitted: 'Submitted',
  Read: 'Read'
} as const

export type TaskStatus = (typeof TaskStatus)[keyof typeof TaskStatus]


export const ChecklistItemType = {
  YesNo: 'YesNo',
  Text: 'Text',
  TextArea: 'TextArea',
  Number: 'Number'
} as const

export type ChecklistItemType = (typeof ChecklistItemType)[keyof typeof ChecklistItemType]
